module.exports = __webpack_public_path__ + "static/media/pending.d23794d1.svg";